<template>
  <custom-dialog width="850px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="add-user-orgin-dialog">
        <div class="title">
          <h1>{{ $t('base_user_organ_bind_dialog.xuan_ze_bu_men') }}</h1>
          <h2>{{ $t('base_user_organ_bind_dialog.ygkglckjrdbmzdsyjq') }}</h2>
        </div>
        <div class="wrap">
          <!-- 部门搜索 -->
          <div class="search">
            <el-form>
              <el-form-item>
                <el-input :placeholder="$t('base_user_organ_bind_dialog.bu_men_ming_cheng')" v-model="appKey" @input="filterTree" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <!-- 部门结构树 -->
          <div class="tree">
            <el-tree
              ref="tree"
              node-key="bizId"
              :data="organTree"
              :props="{ label: 'bizName' }"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :default-expanded-keys="expandedKeys"
              :check-strictly="true"
              :filter-node-method="filterNode"
              highlight-current
            >
              <span class="tree-item" slot-scope="{ node }">
                <span>{{ node.label }}</span>
                <span>
                  <el-checkbox v-model="node.checked">{{ $t('base_user_organ_bind_dialog.jia_ru') }}</el-checkbox>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveOrganUser">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appKey: '',
      organTree: [],
      expandedKeys: [],
      organData: {},
      userOrgId: '',
    };
  },
  mounted() {
    this.getOrganTree(this.getUserOrganList);
  },
  methods: {
    // 选中部门
    handleNodeClick: function (data) {
      this.organData = data;
    },
    // 搜索过滤事件
    filterTree: function (value) {
      this.$refs.tree.filter(value);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.bizName.indexOf(value) !== -1;
    },
    // 获取组织树
    getOrganTree: function (cb) {
      cb = cb || function () {};
      if (!this.model.data.userId) {
        return;
      }
      this.$getJSON(apis.DepartmentTree, { orgId: this.model.data.orgId }).then((res) => {
        this.expandedKeys = [res.data.bizId];
        this.organTree = [res.data];
        const obj = res.data || {};
        this.userOrgId = obj.orgId;
        cb();
      });
    },
    // 获取用户组织列表
    getUserOrganList: function () {
      if (!this.model.data.userId) {
        return;
      }
      this.$getJSON(apis.UserDepartmentBindList, {
        userId: this.model.data.userId
      }).then((res) => {
        this.$refs.tree.setCheckedKeys(res.data);
      });
    },
    // 保存提交
    saveOrganUser: function () {
      const selected = this.$refs.tree.getCheckedNodes();
      if (!selected.length) {
        this.$message.error(this.$t('base_user_organ_bind_dialog.qzsxzygbm'));
        return;
      }
      const params = {
        userId: this.model.data.userId,
        orgDepartments: selected.map(t => ({
          bizId: t.bizId,
          bizType: t.bizType
        }))
      };
      this.$postJSON(apis.UserDepartmentBind, params, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.clearKeepAlive('department');
        this.visible = false;
      });
      // const params2 = selected.map(t => ({
      //   bizId: this.model.data.userId,
      //   bizType: 3,
      //   toBizId: t.bizId,
      //   toBizType: t.bizType,
      //   orgId: this.model.data.orgId || this.userOrgId,
      // }));
      // this.$postJSON(apis.organDeviceBindAutoAdd, params2).then(() => {
      // });
    }
  }
};
</script>

<style lang="scss">
.add-user-orgin-dialog {
  .title {
    position: relative;
    h1 {
      line-height: 20px;
      font-weight: bold;
      color: #404040;
      font-size: 14px;
    }
    h2 {
      color: #999999;
      font-size: 12px;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  .wrap {
    border: 1px solid rgba(230, 235, 242, 1);
    padding: 10px;
  }
  .tree {
    height: 410px;
    overflow-y: auto;
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
}
</style>
